import { useDestinationContext } from '@/src/contexts'

import CostOfLiving from './costOfLiving'

const CostOfLivingWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const col = sections.costOfLiving
    if (!col) return null

    const l = col.labels

    const priceRows = [
        { label: l?.budgetMealEstimate ?? 'Budget meal', value: col.budgetMealEstimate },
        { label: l?.midRangeMealEstimate ?? 'Mid-range meal', value: col.midRangeMealEstimate },
        { label: l?.publicTransportTicket ?? 'Public transport', value: col.publicTransportTicket },
        { label: l?.coffeeShop ?? 'Coffee shop', value: col.coffeeShop },
    ].filter(r => r.value)

    const infoFacts = [
        col.currency ? { label: l?.currency ?? 'Currency', value: `${col.currency.name} (${col.currency.code})` } : null,
        { label: l?.language ?? 'Language', value: col.language?.official },
        { label: l?.timezone ?? 'Timezone', value: col.timezone ? `${col.timezone} (UTC${col.utcOffset})` : undefined },
    ].filter((r): r is { label: string; value: string } => !!r?.value)

    return (
        <CostOfLiving
            priceRows={priceRows}
            infoFacts={infoFacts}
            tipping={col.tipping}
            tippingLabel={l?.tipping}
            currencySymbol={col.currency?.symbol}
            sectionTitle={l?.sectionTitle}
            priceEstimatesTitle={l?.priceEstimatesTitle}
        />
    )
}

export default CostOfLivingWrapper
